<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              color="primary"
              v-if="!screen.readOnly"
              >「新規登録」はこのボタンを押してください</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{
                $formTitle("ユーザ", screen.readOnly, isNew)
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isPassedValidation">
                <v-container fluid>
                  <v-row v-if="isNew">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        attach
                        v-model="editedItem.municip_code"
                        :items="municipalitiesWithNational"
                        :rules="[$validation.rules.required]"
                        label="国/自治体"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        v-bind="formControlProps()"
                        @change="changeMunicipalityForEdit"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        attach
                        v-model="editedItem.organize_id"
                        :items="organizationsForEdit"
                        :rules="[$validation.rules.required]"
                        label="組織名"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        item-text="organize_name"
                        item-value="organize_id"
                        v-bind="formControlProps()"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isNew">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.login_id_suffix"
                        :rules="[
                          $validation.rules.required,
                          $validation.rules.loginId
                        ]"
                        label="ログインID"
                        :placeholder="config.PLACEHOLDER_LOGIN_ID"
                        v-bind="formControlProps(3)"
                        :prefix="loginIdPrefix"
                        :error-messages="loginIdErrorMessage(editedItem)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isNew">
                    <v-col
                      class="input-Password"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="editedItem.password"
                        :rules="[$validation.rules.required, passwordChk]"
                        name="password"
                        label="パスワード"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        v-bind="formControlProps(256)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <p
                    v-if="isNew"
                    class="isNewPasswordPolicyFirstRow"
                    v-text="passwordPolicyPreviousRow"
                  ></p>
                  <p
                    v-if="isNew"
                    class="isNewPasswordPolicySecondRow"
                    v-text="passwordPolicyNextRow"
                  ></p>
                  <v-row v-if="isNew">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.password_re"
                        :rules="[
                          $validation.rules.required,
                          passwordReInputChk
                        ]"
                        label="パスワード（確認用）"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        v-bind="formControlProps(256)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.user_name"
                        :rules="[$validation.rules.required]"
                        label="ユーザ名"
                        :placeholder="config.PLACEHOLDER_INPUT"
                        v-bind="formControlProps(20)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        attach
                        v-model="editedItem.ope_auth_gp_id"
                        :items="operationAuthorityGroups"
                        label="操作権グループ名"
                        :placeholder="config.PLACEHOLDER_SELECT"
                        item-text="ope_auth_gp_name"
                        item-value="ope_auth_gp_id"
                        v-bind="formControlProps()"
                        :rules="[$validation.rules.required]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-checkbox
                        v-if="!isNew"
                        v-model="editedItem.isUpdatePassword"
                        value="1"
                        label="パスワードの再設定"
                        @change="liftValidation"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-form
                    ref="resetTarget"
                    v-model="isPassedPasswordValidation"
                  >
                    <v-row v-if="!isNew">
                      <v-col
                        class="input-Password"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                      >
                        <v-text-field
                          v-model="editedItem.password"
                          :rules="[$validation.rules.required, passwordChk]"
                          label="パスワード"
                          :placeholder="showPlaceHolder"
                          v-bind="formControlProps(256)"
                          :class="{
                            'v-text-field--filled': !editedItem.isUpdatePassword
                          }"
                          :disabled="!editedItem.isUpdatePassword"
                          clearable
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <p
                      v-if="!isNew"
                      class="isNewPasswordPolicyFirstRow"
                      v-text="passwordPolicyPreviousRow"
                    ></p>
                    <p
                      v-if="!isNew"
                      class="isNewPasswordPolicySecondRow"
                      v-text="passwordPolicyNextRow"
                    ></p>
                    <v-row v-if="!isNew">
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.password_re"
                          :rules="[
                            $validation.rules.required,
                            passwordReInputChk
                          ]"
                          label="パスワード（確認用）"
                          :placeholder="showPlaceHolder"
                          v-bind="formControlProps()"
                          :class="{
                            'v-text-field--filled': !editedItem.isUpdatePassword
                          }"
                          :disabled="!editedItem.isUpdatePassword"
                          clearable
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- ボタンの活性・非活性切り替え※v-fomrのv-modelの値を参照し判定 -->
              <v-btn
                class="mx-2"
                color="primary"
                @click="save"
                :disabled="
                  editedItem.isUpdatePassword
                    ? !(isPassedPasswordValidation && isPassedValidation)
                    : !isPassedValidation
                "
              >
                {{ saveBtnText }}
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="close">
                {{ $cancelButtonText(screen.readOnly) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          ユーザ情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.municipality"
              :items="[...municipalitiesWithNational]"
              label="国/自治体"
              :placeholder="config.PLACEHOLDER_SELECT"
              @change="changeMunicipality"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.organization"
              :items="filteredOrganizations"
              label="組織名"
              item-text="organize_name"
              item-value="organize_id"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.operationAuthorityGroup"
              :items="[...operationAuthorityGroups]"
              label="操作権グループ名"
              item-text="ope_auth_gp_name"
              item-value="ope_auth_gp_id"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="searchItem.userName"
              label="ユーザ名"
              :placeholder="config.PLACEHOLDER_INPUT"
              append-icon="mdi-magnify"
              clearable
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="searchItem.loginId"
              label="ログインID"
              :placeholder="config.PLACEHOLDER_INPUT"
              append-icon="mdi-magnify"
              clearable
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
      </v-container>
      <top-operation-data-table
        :headers="headers"
        :items="items"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        dispMode="nowrap"
        locale="ja-jp"
        item-key="user_id"
        must-sort
        class="fixedWidth"
        ref="resetPagination"
      >
        <template v-slot:[`item.municip_code`]="{ item }">
          {{ municipalityName(item) }}
        </template>
        <template v-slot:[`item.organize_id`]="{ item }">
          {{ item.organize_name }}
        </template>
        <template v-slot:[`item.ope_auth_gp_id`]="{ item }">
          {{ item.ope_auth_gp_name }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="editItem(item)">
            編集
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="deleteItem(item)"
            v-if="screen.hasDeleteAuthority"
          >
            削除
          </v-btn>
        </template>
      </top-operation-data-table>
      <confirm-dialog ref="confirmDelete" />
    </v-sheet>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import FormUtils from "@/plugins/form-utils";
import { ScreenId } from "@/js/value-objects/screen-id";
import { UserTranslator } from "@/js/translators/userTranslator";
import { SaveType } from "@/js/value-objects/save-type";
import messageUtils from "@/mixins/message-utils";
import Validation from "@/plugins/validation";
import "@/css/styles.css";
import { LoginId } from "@/js/value-objects/login-id";
import config from "@/js/const";
import { ErrorTodoMessages } from "@/js/constants/error-messages";

Vue.use(FormUtils, Validation);

const disasterStaffMstRepository = RepositoryFactory.get("disasterStaffMst");

const SEARCH_ITEM = Object.freeze({
  userName: "",
  municipality: "",
  organization: "",
  operationAuthorityGroup: "",
  loginId: ""
});
const USER_ITEM = Object.freeze({
  municip_code: "",
  user_id: "",
  login_id_suffix: "",
  user_name: "",
  organize_id: "",
  ope_auth_gp_id: "",
  password: "",
  isUpdatePassword: false
});

export default {
  mixins: [messageUtils],

  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  data: () => ({
    overlay: false,
    dialog: false,
    config: config,
    screen: null,
    items: [],
    editedIndex: -1,
    searchItem: cloneDeep(SEARCH_ITEM),
    editedItem: cloneDeep(USER_ITEM),
    defaultItem: cloneDeep(USER_ITEM),
    organizations: [],
    filteredOrganizations: [],
    organizationsForEdit: [],
    municipalitiesWithNational: [],
    operationAuthorityGroups: [],
    loginIdPrefix: "",
    isPassedValidation: false,
    isPassedPasswordValidation: false,
    passwordPolicyPreviousRow:
      "パスワードには大小英文字、数字、記号をそれぞれ１文字以上含め、１０文字以上で入力してください。",
    passwordPolicyNextRow:
      "ご利用いただける記号一覧：　= + - ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ `"
  }),

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  computed: {
    headers() {
      let headers = [
        {
          text: "国/自治体",
          value: "municip_code",
          filter: this.municipalityNameFilter
        },
        {
          text: "組織名",
          value: "organize_id",
          filter: this.organizationNameFilter
        },
        {
          text: "操作権グループ名",
          value: "ope_auth_gp_id",
          filter: this.operationAuthorityGroupNameFilter
        },
        {
          text: "ユーザ名",
          value: "user_name",
          filter: this.userNameFilter
        },
        {
          text: "ログインID",
          value: "user_id",
          filter: this.loginIdFilter
        }
      ];
      if (this.screen.readOnly) {
        return headers;
      }
      headers.push({
        text: "操作",
        value: "actions",
        sortable: false
      });
      return headers;
    },
    // 新規登録判定
    isNew() {
      return this.editedIndex === -1;
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(this.screen.readOnly, counter);
      };
    },
    // 登録・更新ボタン表示切替
    saveBtnText() {
      return this.isNew ? "登録" : "更新";
    },

    sort() {
      return {
        by: ["municip_code"],
        desc: [true]
      };
    },
    // 編集画面のパスワード項目非活性時プレースホルダー空表示
    // 空にしてしまうとlabelがプレースホルダーに置換されるため空文字挿入
    showPlaceHolder() {
      if (this.editedItem.isUpdatePassword) {
        return config.PLACEHOLDER_INPUT;
      } else {
        return " ";
      }
    },
    //パスワードフォーマットバリデーション
    passwordChk() {
      return (
        /^(?=.*[!-/:-@[-`{-~])(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[!-~]{10,256}$/.test(
          this.editedItem.password
        ) || ErrorTodoMessages.ERWE40036
      );
    },
    // パスワードとパスワード（確認用）の一致バリデーション
    passwordReInputChk() {
      return (
        this.editedItem.password_re === this.editedItem.password ||
        ErrorTodoMessages.ERWE40029
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    editedItem: {
      handler: function(newItem) {
        this.loginIdPrefix = "";
        if (this.isNew) {
          this.loginIdPrefix = LoginId.factory(
            newItem.municip_code,
            ""
          ).prefix();
        }
      },
      deep: true
    },
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;

      this.screen = this.$screenOperationAuthority(
        ScreenId.SF1201,
        ScreenId.SF1207
      );

      try {
        await Promise.all([
          await this.$store
            .dispatch(
              "disasterStaffMst/loadDisasterStaffMst",
              this.screen.screenId
            )
            .then(() => {
              this.items = this.$store.state.disasterStaffMst.data.results;
            }),
          await this.$store
            .dispatch("allAreaWithNational/loadAllArea")
            .then(() => {
              const municipalities = this.$store.state.allAreaWithNational
                .municipalities;
              const prefectures = this.$store.state.allAreaWithNational
                .prefectures;
              this.municipalitiesWithNational = prefectures.concat(
                municipalities
              );
            }),
          await this.$store
            .dispatch("organizeMst/loadOrganizeMst", this.screen.screenId)
            .then(() => {
              this.organizations = orderBy(
                this.$store.state.organizeMst.data.results,
                ["disp_no"]
              );
              this.filteredOrganizations = Object.assign(
                [],
                this.organizations
              );
            }),
          await this.$store
            .dispatch("opeAuthMst/loadOpeAuthMst", this.screen.screenId)
            .then(() => {
              this.operationAuthorityGroups = orderBy(
                this.$store.state.opeAuthMst.data.results,
                ["disp_no"]
              );
            })
        ]);
      } catch (e) {
        this.handleError(e, this.screen.screenId, "aggregation-menu");
      }

      this.overlay = false;
    },

    municipalityName(item) {
      const data = this.municipalitiesWithNational.find(
        obj => obj.value === item.municip_code
      );
      if (data) {
        return data.text;
      }
      return "";
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.changeMunicipalityForEdit(item.municip_code, false);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.editedItem.isUpdatePassword = false;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async deleteItem(item) {
      let message = `ログインID「${item.user_id}」のユーザ情報を削除しますか？`;
      if (!(await this.deleteConfirm(message))) {
        return false;
      }
      message = "削除した場合には元に戻せません。本当によろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return false;
      }
      await this.save(SaveType.factoryDelete(), item);
    },

    deleteConfirm(message) {
      return this.$refs.confirmDelete.open(message, "削除");
    },
    //登録・更新処理
    async save(saveType = null, item = {}) {
      if (!(saveType instanceof SaveType) || !saveType.isDelete()) {
        saveType = SaveType.factoryFromNewFlg(this.isNew);
      }
      if (saveType.isCreateOrUpdate()) {
        if (this.$refs.form.validate() === false) {
          return;
        }
        if (this.loginIdErrorMessage(this.editedItem)) {
          return;
        }
        item = cloneDeep(this.editedItem);
      }
      this.overlay = true;
      this.clearMessage();
      const payload = UserTranslator.toPayload(item, saveType);
      if (saveType.isCreate()) {
        await disasterStaffMstRepository
          .create(ScreenId.SF1202, payload)
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleCreateError(e);
          })
          .finally(this.initialize());
      } else if (saveType.isUpdateOrDelete()) {
        await disasterStaffMstRepository
          .update(
            saveType.isUpdate() ? ScreenId.SF1203 : this.screen.screenId,
            payload
          )
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      }
      if (saveType.isCreateOrUpdate()) {
        await this.close();
      }
      this.overlay = false;
      await this.initialize();
    },

    userNameFilter(value) {
      this.resetPage();
      if (!this.searchItem.userName) {
        return true;
      }
      return value.includes(this.searchItem.userName);
    },

    loginIdFilter(value) {
      this.resetPage();
      if (!this.searchItem.loginId) {
        return true;
      }
      return value.includes(this.searchItem.loginId);
    },

    municipalityNameFilter(value) {
      this.resetPage();
      if (!this.searchItem.municipality) {
        return true;
      }
      return value === this.searchItem.municipality;
    },

    organizationNameFilter(value) {
      this.resetPage();
      if (!this.searchItem.organization) {
        return true;
      }
      return value === this.searchItem.organization;
    },

    operationAuthorityGroupNameFilter(value) {
      this.resetPage();
      if (!this.searchItem.operationAuthorityGroup) {
        return true;
      }
      return value === this.searchItem.operationAuthorityGroup;
    },
    /**検索時にページネーションをリセット
     * 初期表示ではテーブルが生成されていないためデータテーブルのメソッドが
     * 呼び出せない。生成されていることを確認してから呼びだす。
     */
    resetPage() {
      if (this.$refs.resetPagination) {
        this.$refs.resetPagination.resetPage();
      }
    },
    loginIdErrorMessage(item) {
      if (!this.isNew) {
        return "";
      }
      const loginId = LoginId.factory(item.municip_code, item.login_id_suffix);
      if (loginId.isEmpty()) {
        return "";
      }
      const hasUserId = this.items.some(
        item => item.user_id === loginId.toUserId()
      );
      if (!hasUserId) {
        return "";
      }
      return "既に登録されています。";
    },

    async changeMunicipality(municipality) {
      // 組織のフィルタ内容をリセットする
      this.searchItem.organization = undefined;
      // 組織の候補をリセットする
      this.filteredOrganizations = [];

      if (!municipality) {
        // 未選択の場合の処理
        this.filteredOrganizations = Object.assign([], this.organizations);
      } else {
        // それ以外の処理
        this.filteredOrganizations = this.organizations.filter(
          organization => organization.municip_code === municipality
        );
      }
    },

    async changeMunicipalityForEdit(municipality, isClearOrganize = true) {
      this.organizationsForEdit = this.organizations.filter(
        organization => organization.municip_code === municipality
      );
      if (isClearOrganize) {
        Object.assign(this.editedItem, { organize_id: "" });
      }
    },
    // パスワード再設定のチェック解除時にバリデーションメッセージとinput値リセット
    liftValidation(isUpdatePassword) {
      if (!isUpdatePassword) {
        this.$refs.resetTarget.reset();
      }
    }
  }
};
</script>
<style scoped>
/* パスワードポリシー表示欄レイアウト */
.isNewPasswordPolicyFirstRow {
  margin-bottom: 0px;
}
.isNewPasswordPolicySecondRow {
  white-space: pre-wrap;
  margin-top: 0px;
}
.input-Password {
  padding-bottom: 0px;
}
</style>
